import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { HIGHLIGHT_CARD_LOADER } from '../../constants/dataTestIds';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const HighlightCard = ({
  children,
  ['data-test-id']: dataTestId,
  errorMessage,
  loading
}) => {
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": HIGHLIGHT_CARD_LOADER,
      grow: true,
      minHeight: 128
    });
  }
  if (errorMessage) {
    throw new Error(errorMessage);
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(View, {
      paddingInline: "600",
      paddingBlockStart: "600",
      paddingBlockEnd: "0",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-default",
      borderBlockEndWidth: "100",
      children: children
    })
  });
};
export default HighlightCard;